var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon",class:_vm.extraClass},[(_vm.value)?_c('i',{staticClass:"fa fa-check-square"}):_c('i',{staticClass:"fa fa-times"})])
}
var staticRenderFns = []

export { render, staticRenderFns }